export {Affix} from 'antd';
export type {AffixProps, AffixState} from 'antd/es/affix/index';
